import PropTypes from 'prop-types';
import React from 'react';

import ToggleColumn from './ToggleColumn';

export default function TestingStatusToggleColumn({ row, col, cell }) {
  if (row.isLive.value) {
    return <span>In Testing</span>;
    // eslint-disable-next-line eqeqeq
  } if ((row.Original_Data.variants && row.Original_Data.variants != 1) || !row.Original_Data.isEditable) {
    return <div>{row.Enable.value ? 'On' : 'Off'}</div>;
  }
  return ToggleColumn({ row, col, cell });
}

TestingStatusToggleColumn.defaultWidth = 100;

TestingStatusToggleColumn.propTypes = {
  row: PropTypes.shape({
    isLive: PropTypes.any,
    Enable: PropTypes.any,
    Original_Data: PropTypes.shape({
      variants: PropTypes.any,
      isEditable: PropTypes.any,
    }),
  }).isRequired, // row data
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onText: PropTypes.string,
      offText: PropTypes.string,
      onColor: PropTypes.string,
      offColor: PropTypes.string,
      onClick: PropTypes.func.isRequired, // (row, value) :=> {}
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    value: PropTypes.any,
    isDisabled: PropTypes.bool,
    isColumnDisabled: PropTypes.bool,
    tooltipText: PropTypes.string,
  }).isRequired,
};
